module.exports = __webpack_public_path__ + "img/chevron-left.99860f19.svg";